import 'twin.macro';
import React, { useState } from 'react';
import Input from '@teetsh/app/src/components/Form/Input2';
import Dialog from '@teetsh/app/src/components/Dialog';
import Button from '@teetsh/app/src/components/Buttons/Button';
import useDeleteAccount from '@teetsh/app/src/queries/user/useDeleteAccount';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Trans, useTranslation } from 'react-i18next';
import { Infobox } from '@teetsh/app/src/components/Callout/Infobox';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function DeleteAccountModal(props: Props) {
  const [text, setText] = useState<string>('');
  const { t } = useTranslation(['userSettings', 'common']);
  const { deleteAccount, isLoading } = useDeleteAccount();
  return (
    <Dialog isOpen={props.isOpen} size="md" onClose={props.onClose}>
      <Dialog.Body>
        <Infobox intent="danger" tw="mb-2">
          <p>
            <Trans i18nKey="userSettings:deleteAccount.warning">
              Ceci supprimera <strong>DÉFINITIVEMENT</strong> toutes les données
              relatives à votre compte.
            </Trans>
          </p>
          <p tw="pt-2">
            <Trans
              i18nKey="userSettings:deleteAccount.typeDeleteText"
              values={{
                deleteText: t('userSettings:deleteAccount.deleteText'),
              }}
            >
              Tapez ci-dessous
              <strong>
                <code></code>
              </strong>
              pour pouvoir supprimer votre compte.
            </Trans>
          </p>
        </Infobox>
        <Input
          autoFocus
          id="delete-account"
          value={text}
          onChange={e => setText(e?.currentTarget?.value || '')}
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Button large minimal onClick={() => props.onClose()}>
          {t('common:buttons.cancel')}
        </Button>
        <Button
          large
          loading={isLoading}
          intent="danger"
          onClick={() => deleteAccount().then(() => props.onClose())}
          disabled={
            text.trim() !== t('userSettings:deleteAccount.deleteText') ||
            isLoading
          }
          icon={TrashIcon}
        >
          {t('common:buttons.delete')}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}
